import * as React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { ExareStatus } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { format, getTravellerName } from '../../../../../utils';
import { getLastExchange, getLastExchangeFlights } from '../../../../../Checkout/store/order/selectors';
import Notice from '../../../../../RefundSummary/components/Notice/Notice';
import { ExchangeRefundRequest } from '@entities/order';
import { getCalculatedExchangePrices } from '@entities/exchange/lib/getCalculatedExchangePrices';
import { Receipt } from '../Receipt';
import { SelectedFlights } from '../SelectedFlights';
import { ExchangeRequestControls } from '../ExchangeRequestControls';
const ExchangeTicket = ({ className }) => {
    const { t } = useTranslation('Exchange');
    const { Request: theme } = useTheme('Widgets').Exchange;
    const lastExchange = useSelector(getLastExchange);
    const lastExchangeSelectedFlights = useSelector(getLastExchangeFlights);
    const breadcrumbs = [
        ...lastExchange.travellers.map(traveller => ({
            id: `traveller/${traveller.id}`,
            label: getTravellerName(traveller)
        })),
        ...lastExchangeSelectedFlights.map((flight, index) => ({
            id: `flight/${index}`,
            label: [
                flight.segments[0].segment.departure.airport.city.name,
                flight.segments[0].segment.arrival.airport.city.name
            ].join(' — ')
        }))
    ];
    const showTimeLimitNotice = lastExchange.status === ExareStatus.AwaitingPayment || lastExchange.status === ExareStatus.TimelimitExpired;
    const showManagerCommentNotice = lastExchange.status === ExareStatus.Rejected && lastExchange.managerRejectComment;
    const exchangePrices = useMemo(() => {
        return getCalculatedExchangePrices(lastExchange.prices);
    }, [lastExchange.prices]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(theme.ticket, className) },
            React.createElement(ExchangeRefundRequest, { createDate: new Date(lastExchange.createDate), status: lastExchange.status, timeLimit: new Date(lastExchange.timelimit), comment: lastExchange.userComment, breadcrumbs: breadcrumbs, ns: "Exchange" }),
            React.createElement(SelectedFlights, { className: theme.ticket__flights, selectedFlights: lastExchangeSelectedFlights, hideHeader: true }),
            React.createElement(Receipt, { className: theme.receipt, prices: [
                    { label: t('ExchangeReceipt.TicketPrice'), price: exchangePrices.ticket },
                    { label: t('ExchangeReceipt.PenaltyPrice'), price: exchangePrices.charge }
                ], totalPrice: exchangePrices.total }),
            (showTimeLimitNotice || showManagerCommentNotice) && (React.createElement("div", { className: theme.notifications },
                showTimeLimitNotice && (React.createElement(Notice, { className: theme.notification, type: "time", header: t('Limited exchange time'), text: t('Offer valid until {{date}}', {
                        date: format(lastExchange.timelimit, 'dd MMMM yyyy, HH:mm')
                    }) })),
                showManagerCommentNotice && (React.createElement(Notice, { className: theme.notification, type: "reject", header: t('Rejection reason'), text: lastExchange.managerRejectComment }))))),
        React.createElement(ExchangeRequestControls, null)));
};
export default ExchangeTicket;
